import React from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import type { FormInstance } from 'antd';

import { Tasks } from '../Tasks';
import { UploadFile } from '../UploadFile';
import { TitleFormItem } from './TitleFormItem';
import { DueDateFormItem } from './DueDateFormItem';
import { PriorityFormItem } from './PriorityFormItem';
import { ResponsibleFormItem } from './ResponsibleFormItem';
import { DescriptionFormItem } from './DescriptionFormItem';
import { InvestmentRangeFormItem } from './InvestmentRangeFormItem';
import { useResponsible } from '../_hooks/useResponsible';

import * as S from '../styles';

interface ActionPlanFormProps {
	risk: string | JSX.Element;
	form: FormInstance;
	initialValues: any;
	descriptionTasks?: string;
	modal?: boolean;
	origin_table: string;
	table_origin_id: string;
	actionPlanId?: string;
}

export function ActionPlanForm({
	form,
	initialValues,
	risk,
	descriptionTasks = '',
	modal = false,
	origin_table,
	table_origin_id,
	actionPlanId
}: Readonly<ActionPlanFormProps>) {
	const { usersOptions, isLoading } = useResponsible();

	return (
		<Form form={form} initialValues={initialValues} layout="vertical">
			<Row gutter={[32, 16]}>
				<Col span={12}>
					<TitleFormItem />
				</Col>
				<Col>
					<S.CustomLabel>{I18n.get('Risk')}</S.CustomLabel>
					{risk}
				</Col>
				<Col span={12}>
					<ResponsibleFormItem usersOptions={usersOptions} isLoading={isLoading} />
				</Col>
				<Col span={12}>
					<DueDateFormItem />
				</Col>
				<Col span={12}>
					<PriorityFormItem />
				</Col>
				<Col span={12}>
					<S.CustomLabel>{I18n.get('Investment')}</S.CustomLabel>
					<InvestmentRangeFormItem />
				</Col>
				<Col span={24}>
					<UploadFile origin_table={origin_table} table_origin_id={table_origin_id} />
				</Col>
				<Col span={24}>
					<DescriptionFormItem />
				</Col>
				<Col span={24}>
					<Tasks
						users={usersOptions}
						descriptionTasks={descriptionTasks}
						modal={modal}
						actionPlanId={actionPlanId}
					/>
				</Col>
			</Row>
		</Form>
	);
}
